/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WorkCenterTaskStatus {
  Ok = 'Ok',
  NotOk = 'NotOk',
  AutoOk = 'AutoOk'
}
